import { DropDown } from '~elements'
import { DropDownGroupProps } from '~types'
import styles from './DropDownGroup.module.scss'

const DropDownGroup = ({ dropDowns = [], onDropDownChange, theme = 'muted', isLoading, showPlaceholderInMenu }: DropDownGroupProps) => {
  return (
    <div className={styles.dropdownGroupContainer}>
      {dropDowns.map(dropDown => (
        <DropDown key={dropDown.id} {...dropDown} onDropDownChange={onDropDownChange} theme={theme} isLoading={isLoading} showPlaceholderInMenu={showPlaceholderInMenu} />
      ))}
    </div>
  )
}

export default DropDownGroup
